import React from 'react'
import ModalComponent from '../ModalComponent'
import InputField from '../../InputField/InputField';

export default function ConfirmationModal({ visible, title, size = "md", handleClose, handleConfirm, confirmMessage, value, handleOnchange, remark }) {
  return (
    <ModalComponent
      visible={visible}
      title={title}
      size={size}
      handleClose={handleClose}
    >
      <div>
        {!remark &&
          <h2 className="text-black font_600 font_17 mb-3 text-center">
            {confirmMessage}<br />
          </h2>
        }
        <div className="text-end">
          {remark &&
            <div className="w-100 pt-2">
              <InputField
                required
                type={"text"}
                placeholder={"Enter a remark"}
                name={"remark"}
                value={value}
                seterrorMessage={(name, message) => {
                  console.log(name, message);
                }}
                onchange={(value, label, index) => handleOnchange(value, label, index, 'remark')}
              />
            </div>}
          <button onClick={() => handleClose()} style={{border:"1px solid var(--mastercolor)"}} className="btn font_15 font_500 px-3 text_master">
            Cancel
          </button>
          <button className="btn btn-master ms-2 font_15 font_500 px-5" onClick={handleConfirm} disabled={!value}>
            Confirm
          </button>
        </div>
      </div>
    </ModalComponent>
  )
}
